angular.module('impactx.product').controller('PriceRuleCtrl', [
    '$scope',
    '$locale',
    PriceRuleCtrl
]);

function PriceRuleCtrl($scope, $locale) {
    var ctrl = this;
    var formats = $locale.NUMBER_FORMATS;
    var pattern = {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
    };

    $scope.formattedOffset = '';
    $scope.formattedFactor = '';
    if($scope.onlyInput)
        $scope.shown = true;

    ctrl.recalc = function () {
        if(!$scope.onlyInput) {
            $scope.priceLists = $scope.recalcFunc();
        }

        var offset =  $scope.priceRule.offset.value || 0;
        var factor =  $scope.priceRule.factor.value || 0;
        $scope.formattedOffset = formatNumber(offset / 100, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined) + " " + $scope.priceRule.currency.selected.id;
        $scope.formattedFactor = formatNumber(factor, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined) + "%";
    }

    ctrl.delete = function() {
        $scope.priceRule.deleted = true;
    };

    ctrl.toggleShown = function() {
        $scope.shown = !$scope.shown;
    };

    ctrl.recalc();
}